import React from "react";
import { Card, CardHeader } from "../../../components/shadcn-ui/card";
import { ChevronRight, Users, Briefcase } from "lucide-react";
import { Separator } from "../../../components/shadcn-ui/separator";
import { Group } from "../types";

interface GroupCardProps {
    group: Group;
}

export const GroupCard: React.FC<GroupCardProps> = ({ group }) => {
    return (
        <Card className="shadow-sm flex gap-4 items-center p-2 md:p-1 cursor-pointer rounded-md hover:bg-gray-200 hover:border-white transition-colors duration-300 ease-in-out">
            <span className="flex gap-2 md:gap-1 items-center">
                <div className="md:h-8 ml-1 mr-1 rounded-xl bg-blue-100 p-2 flex items-center justify-center">
                    <Users className="h-5 w-5 text-blue-600" />
                </div>
                <Separator
                    orientation="vertical"
                    className="w-px h-12 md:h-8"
                ></Separator>
            </span>
            <div className="flex flex-1 gap-0.5 flex-col md:flex-row items-start md:items-center justify-between">
                <div className="flex-1">
                    <CardHeader className="p-0 text-lg md:text-sm font-semibold leading-none">
                        {group.name}
                    </CardHeader>
                </div>
                <div className="text-sm sm:block text-gray-800 flex-1 font-normal text-muted-foreground">
                    {group.city}
                </div>
                <div className="text-sm text-gray-800 flex-1 sm:block text-muted-foreground">
                    {group.memberCount || 0} members
                </div>
                {group.bdManager && (
                    <div className="text-sm text-gray-800 flex-1 sm:block text-muted-foreground flex items-center gap-1">
                        <Briefcase className="h-3 w-3" />
                        <span>{group.bdManager.name} - {group.bdManager.phoneNumber}</span>
                    </div>
                )}
            </div>
            <div className="h-10 w-10 text-gray-500 flex justify-center items-center">
                <ChevronRight className="text-gray-500" />
            </div>
        </Card>
    );
};
